module.exports = __webpack_public_path__ + "img/1e861e3.jpg";